/** @module SiteAdmin/Locale/ActiveRenderer */
define([
	"dojo/_base/declare",
	"csi/heading/Boolean",
	"csi/html",
	"csi/locale",
	"csi/state"
], function(declare,BooleanRen,html,locale,state) {

	return declare(BooleanRen, {

		/**
		 * Grey out the action if the locale is the current one
		 */
		_getRenderAction: function(ctx, h) {
			return this._isSiteLocale(ctx) ? null : this.inherited(arguments);
		},

		/**
		 * Return true if the current locale is the site locale
		 * @param {Context} ctx
		 * @return {boolean}
		 */
		_isSiteLocale: function(ctx) {
			var siteLocale = state.get("siteLocale");
			var locale = ctx.getNodeParent();
			return locale.$Name == siteLocale;
		},

		/**
		 * show the tooltip for the current locale
		 */
		toTooltip: function(ctx, h, tooltip) {
			if (this._isSiteLocale(ctx)) {
				tooltip.addContent(html.create("div", {innerText: locale.resource("DeactivateLocaleWarning")}));
			}

			return this.inherited(arguments);
		}
	});
});